const env = process.env.VUE_APP_ENV;
let API = null;
let CREATEUSER = null;
let TITLEAPP = "SG Controle";
let PRODUCTION = null;
let WHATSAPP_API = null;

switch (env) {
	case "production":
		API = "/api";
		CREATEUSER = "https://appcontas.informaticasg.com.br";
		WHATSAPP_API = "https://appcontas.informaticasg.com.br";
		PRODUCTION = true;
		break;
	case "staging":
		API = "/api";
		CREATEUSER = "https://appcontas-homo.informaticasg.com.br";
		WHATSAPP_API = "https://appcontas-homo.informaticasg.com.br";
		TITLEAPP = "STAGING";
		break;
	default:
		API = "http://localhost:3000/api";
		CREATEUSER = "http://localhost:3002";
		WHATSAPP_API = "http://localhost:3000";
		TITLEAPP = "DEVELOP";
		break;
}
console.log(env, API );

export default {
	API,
	CREATEUSER,
	TITLEAPP,
	PRODUCTION,
	WHATSAPP_API
};
